import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";

export const Report_promotion_service = {
    getReportData,
    getOldReportData,
    getAvgReportData,
    getBroadbandInternetPerMbps,
    getBroadbandAvgMonth,
    getServiceRegulate,
    getTotalViewAll,
    getTotalViewByType,
    getQuarterRateMobile,
    getQuarterFixedMobile,
    getProportionMobileRate,
    get_provider_id,
    getProviderTypeById,
    getBroadbandAvgByTechnology,
    getBroadbandForecast,
    getProportionMobileType,
    getMobileRanking,
    getBroadbandRanking,
    getTopViewMobile,
    getTopViewBroadband,
    getCountFixedMobile,
    getMobilePromotions
}

function getReportData(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getAvgMobileReport/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getOldReportData(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportPromotion/getMobileAvgFixed/?authorization="+ json_cookie.token, {params : data})
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getAvgReportData(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportPromotion/getMobileAvgMonth/?authorization="+ json_cookie.token, {params : data})
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getBroadbandInternetPerMbps(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getBroadbandInternetPerMbps/?authorization="+ json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getBroadbandAvgByTechnology(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getBroadbandAvgByTechnology/?authorization="+ json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getBroadbandForecast(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getBroadbandForecast/?authorization="+ json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
  }

function getBroadbandAvgMonth(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getBroadbandAvgMonth/?authorization="+ json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getServiceRegulate(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportPromotion/getServiceRegulate/?authorization="+ json_cookie.token)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getQuarterRateMobile(params){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getQuarterRateMobile/?authorization="+ json_cookie.token, params)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getQuarterFixedMobile(params){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getQuarterFixedMobile/?authorization="+ json_cookie.token, params)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getTotalViewAll(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getTotalViewAll/?authorization=" + json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getTotalViewByType(data){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getTotalViewByType/?authorization=" + json_cookie.token, data)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getProportionMobileRate(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportPromotion/getProportionMobileRate/?authorization="+ json_cookie.token)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getProportionMobileType(){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.get(config.API_URL + "reportPromotion/getProportionMobileType/?authorization=" + json_cookie.token)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function get_provider_id() {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getProviderId/?authorization=" + json_cookie.token, { admin_id: json_cookie.admin_id })
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}

function getProviderTypeById(id) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getProviderTypeById/?authorization=" + json_cookie.token, {provider_id: id})
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getMobileRanking(filter){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getMobileRanking/?authorization=" + json_cookie.token, filter)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })   
}

function getBroadbandRanking(filter){
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getBroadbandRanking/?authorization=" + json_cookie.token, filter)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })   
}

function getTopViewMobile(formdata) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getTopViewMobile/?authorization=" + json_cookie.token, formdata)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getTopViewBroadband(formdata) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getTopViewBroadband/?authorization=" + json_cookie.token, formdata)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getCountFixedMobile(formdata) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc)
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getCountFixedMobile/?authorization=" + json_cookie.token, formdata)
        .then(response => {
            resolve(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

function getMobilePromotions(data) {
    let user_nbtc = Cookie.get('user_nbtc')
    let json_cookie = JSON.parse(user_nbtc);
    return new Promise((resolve, reject) => {
        axios.post(config.API_URL + "reportPromotion/getMobilePromotions/?authorization=" + json_cookie.token, data)
            .then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
    })
}